import { types } from 'mobx-state-tree';

const VariesBy = types.model('VariesBy', {
  type: types.string,
  value: types.string,
});

const Schema = types
  .model('ProductProperty', {
    availability: types.string,
    availabilityStarts: types.maybeNull(types.string),
    variesBy: types.maybeNull(types.array(VariesBy))
  });

export default Schema;
